import http_request from 'sync/http_request.js'

import config from 'config'

async function submitStudentAudio(chunks, device_uid, headers) {

	const file = new Blob(chunks, {type: 'audio/ogg'})

	const formData = new FormData()
	formData.append('audio', file, 'audio')
	formData.append('Filename', 'audio')
	formData.append('device_uid', device_uid)

	return http_request.post(`${config.api_hub}student/audio`)
		.type(null)
		.withHeaders(headers)
		.send(formData)
}

async function getStudentAudio(slide, headers) {
	return http_request.get(`${config.api_hub}student/audio`)
		.withHeaders(headers)
		.send({
			slide,
		})
}

export {
	submitStudentAudio,
	getStudentAudio,
}
